import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationRouteNames } from '@core/presentation';
import { UsersServices } from '@modules/company-manager/users/domain';
import { NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { NavigationService } from '@core/application';
import { SessionService } from '@core/application/session.service';

@Component({
  selector: 'app-join-organization',
  templateUrl: './join-organization.page.html',
  styleUrls: ['./join-organization.page.scss'],
})
export class JoinOrganizationPage implements OnInit {
  joinForm!: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usersService: UsersServices,
    private notifications: NotificationsService,
    private navigationService: NavigationService,
    private sessionService: SessionService
  ) {
    this.joinForm = this.fb.group({
      inviteCode: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.sessionService.clearSession();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['code']) {
        this.joinForm.patchValue({
          inviteCode: params['code']
        });
      }
      if (params['email']) {
        localStorage.setItem('signup_email', params['email']);
      }
    });
  }

  onJoin() {
    if (this.joinForm.valid) {
      this.isLoading = true;
      const inviteCode = this.joinForm.value.inviteCode;
      this.usersService.verifyCode({ confirmAccountToken: inviteCode }).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res.success) {
            localStorage.setItem('signup_invite_code', inviteCode);
            localStorage.setItem('signup_role', 'customer');
            this.router.navigate(['/authentication', 'employee-info']);
          } else {
            this.notifications.error(res.message || 'Incorrect invite code', {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.notifications.error(
            err.error?.message || 'Error joining organization',
            { duration: 5000, icon: 'alert-outline' }
          );
          // console.error('Error joining organization:', err);
        },
      });
    }
  }

  goBack() {
    this.navigationService.back();
  }
}
